function cityValidator({ input, msgs }) {
  const rule = /^[a-zA-Z\- '’.]+$/;

  // may be in future, we will support additional chars:
  // rule = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/;

  if (!rule.test(input)) {
    return (msgs && msgs.msg) || 'Invalid city.';
  }

  return null;
}

export default cityValidator;
